var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-72 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96 0v96h-96v368h320v-464zm0 0",
    fill: "#ffdaaa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m96 0-96 96h96zm0 0",
    fill: "#ff7956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 232v232h208c-114.96875 0-208-103.769531-208-232zm0 0",
    fill: "#ffc477"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ed1c24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.625 182.054688-22.625 22.632812-22.625-22.632812-11.3125 11.3125 22.625 22.632812-22.625 22.632812 11.3125 11.3125 22.625-22.632812 22.625 22.632812 11.3125-11.3125-22.625-22.632812 22.625-22.632812zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.375 249.945312 22.625-22.632812 22.625 22.632812 11.3125-11.3125-22.625-22.632812 22.625-22.632812-11.3125-11.3125-22.625 22.632812-22.625-22.632812-11.3125 11.3125 22.625 22.632812-22.625 22.632812zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.34375 322.34375 11.3125 11.3125 7.433594-7.433594c28.136718-28.0625 73.683594-28.0625 101.820312 0l7.433594 7.433594 11.3125-11.3125-7.433594-7.433594c-34.386718-34.308594-90.058594-34.308594-124.445312 0zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f56928f9.svg";
export { ForwardRef as ReactComponent };